const { SITE_URL } = require('./metadata');
const locales = [
  {
    id: 1,
    nombre: 'Barrio Martin',
    barrio: '3 de Febrero',
    direccion: '3 de Febrero 380, Rosario',
    horario: 'Lunes a sabados de 9 a 21 hrs',
    whatsapp: '3413080099',
    whatsappDisplay: '+54 9 341 308-0099',
    telefono: '3417690034',
    telefonoDisplay: '341 769-0034',
    email: 'pedidos@garciavidal.com',
    mapaUrl: 'https://www.google.com/maps?q=3%20de%20Febrero%20380%2C%20Rosario%2C%20Santa%20Fe%2C%20Argentina&output=embed',
    mapsLink: 'https://www.google.com/maps/search/?api=1&query=3%20de%20Febrero%20380%2C%20Rosario%2C%20Santa%20Fe%2C%20Argentina',
    tiendaVirtual: {
      meetUrl: 'https://meet.google.com/mvr-cohb-qmo'
    }
  },
  {
    id: 2,
    nombre: 'Sarmiento',
    barrio: 'Centro',
    direccion: 'Sarmiento 1183, Rosario',
    horario: 'Lunes a sabados de 9 a 21 hrs',
    whatsapp: '3413080099',
    whatsappDisplay: '+54 9 341 308-0099',
    telefono: '3416574963',
    telefonoDisplay: '341 657-4963',
    email: 'pedidos@garciavidal.com',
    mapaUrl: 'https://www.google.com/maps?q=Sarmiento%201183%2C%20Rosario%2C%20Santa%20Fe%2C%20Argentina&output=embed',
    mapsLink: 'https://www.google.com/maps/search/?api=1&query=Sarmiento%201183%2C%20Rosario%2C%20Santa%20Fe%2C%20Argentina',
    tiendaVirtual: {
      meetUrl: 'https://meet.google.com/mvr-cohb-qmo'
    }
  }
];
const businessSchema = (siteUrl = SITE_URL) => ({
 '@context': 'https://schema.org', '@type': 'Organization', '@id': `${siteUrl}/#organization`, name: 'Familia Garcia Vidal', url: `${siteUrl}/`,
 location: locales.map(local => ({ '@type': 'Store', '@id': `${siteUrl}/locales#local-${local.id}`, name: `Familia Garcia Vidal - ${local.nombre}`, url: `${siteUrl}/locales`, address: { '@type': 'PostalAddress', streetAddress: local.direccion.replace(', Rosario', ''), addressLocality: 'Rosario', addressRegion: 'Santa Fe', addressCountry: 'AR' }, telephone: local.telefono, email: local.email, hasMap: local.mapsLink }))
});
module.exports = { locales, businessSchema };
